import React, { useState, useEffect, Link } from "react";
import axios from "axios";
import { Cookies } from "../../index.js";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { alert_error, alert_success } from "../../AppContext";
function Ordergoogle() {
    const [nutxuly, setnutxuly] = useState(0);
    const [input, setinput] = useState('');
    const [nutorder, setnutorder] = useState("✔️ Click to Confirm");
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get("apikey");
        event.preventDefault();
        const data = {
            apikey: apikey,
            input: input
        };
        const dsfsdfsdfsf = "https://hust.media/jop/auto/add_user.php";
        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        if (!apikey || !input) {
            alert_error("Please điền đầy đủ thông tin");
            setnutxuly(0);
            setnutorder("điền đủ thông tin");
            return;
        }
        axios
            .post(dsfsdfsdfsf, data)
            .then((response) => testFunction(response))
            .catch((error) => alert_error(error));
    }
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        setnutxuly(0);
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    return (
        <>
            <form className=" mt-3  mx-2 mx-auto max-w-xl add-form">
                <div className="mb-2 form-control">
                    <div className="mt-1 text-xslg:text-base">
                        <label
                            htmlFor="pin-input"
                            className="inline-block font-bold mb-1"
                        >
                            <small className="inline-block text-gray-500 ">
                                (khác với tk hiện tại để dùng 2 tk)
                            </small>
                        </label>
                        <input
                            id="pin-input"
                            type="text"
                            className="block w-full text-base px-3 py-2 outline-pink-400 
                        font-bold text-green-500 border border-pink-400 rounded-md placeholder:text-xs"
                            placeholder="Nhập tên tài khoản"
                            onChange={(e) => setinput(e.target.value)}
                        />

                    </div>
                    <button disabled={nutxuly == 1}
                        onClick={handleSubmit}
                        className="my-3 mb-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                    >
                        <div className="flex items-center justify-between flex-1">
                            {nutxuly == 1 && (
                                <div className="spinner-border" role="status"></div>
                            )}

                            <span className="text-lg font-medium text-white">
                                {nutorder}{" "}
                            </span>
                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                        </div>
                    </button>
                </div></form>
        </>
    )
}

export default Ordergoogle;
